import './Player.css';
import React from 'react';
import { subtitlesServices } from '../services/subtitles';
import { getUrlParameter } from '../helpers';
import Analytics from '../analytics';

class Player extends React.Component {
  componentDidMount() {
    this.initKalturaPlayer();
  }

  getKalturaPlayerConfig() {
    const autoplay =
      getUrlParameter('autoplay') === 'true' ||
      String(getUrlParameter('autoplay')) === '1';

    return {
      targetId: 'meWATCHPlayer',
      provider: {
        partnerId: process.env.REACT_APP_PARTNER_ID,
        ks: this.props.ks,
        env: { serviceUrl: process.env.REACT_APP_KALTURA_SERVICE_URL },
      },
      playback: {
        autoplay,
        allowMutedAutoPlay: true,
        pictureInPicture: false,
        playsinline: true,
        options: {
          html5: {
            hls: {
              maxBufferLength: 6,
              maxBufferSize: 2000000,
              maxMaxBufferLength: 40,
              capLevelToPlayerSize: true,
              debug: true,
              appendErrorMaxRetry: 10,
            },
          },
        },
      },
      plugins: {
        ottAnalytics: {
          serviceUrl: process.env.REACT_APP_KALTURA_SERVICE_URL,
        },
        youbora: {
          options: {
            accountCode: 'mediacorp',
            username: '',
          },
        },
        vr: { toggleStereo: true },
        ima: '',
      },
    };
  }

  getSubtitles = async () => {
    const subtitlesResponse = await subtitlesServices.getSubtitles(
      this.props.mediaID
    );
    const subtitleList = [];
    for (let subs in subtitlesResponse.data.subtitleFiles) {
      const { subtitleFileUrl, subtitleFileCode, subtitleFileLanguage } =
        subtitlesResponse.data.subtitleFiles[subs];

      subtitleList.push({
        url: subtitleFileUrl,
        language: subtitleFileCode,
        label: subtitleFileLanguage,
        type: 'srt',
      });
    }
    return subtitleList;
  };

  initKalturaPlayer = async () => {
    const KalturaPlayer = window.KalturaPlayer;

    // Append subtitles to player config
    const playerConfig = {
      ...this.getKalturaPlayerConfig(),
      sources: {
        captions: await this.getSubtitles(),
      },
    };
    const analytics = new Analytics(this.props.mediaID);
    const analyticsData = await analytics.init();

    // Get video analytics metadata for use in player init
    const { videoAnalyticsData } = analyticsData;
    const { comscore: comscoreParams, omniture: omnitureParams } =
      videoAnalyticsData;

    if (comscoreParams) {
      // Append comscore plugin to player config
      playerConfig.plugins = {
        ...playerConfig.plugins,
        comscore: comscoreParams,
      };
    }

    try {
      const kalturaPlayer = KalturaPlayer.setup(playerConfig);
      kalturaPlayer.loadMedia({
        entryId: this.props.mediaID,
        fileIds: this.props.fileId,
      });

      /*==
      * Player Events
      ==*/

      kalturaPlayer.addEventListener(kalturaPlayer.Event.MEDIA_LOADED, () => {
        // Init Omniture Video Tracking
        if (window.omniInitMediaTracking) {
          window.omniInitMediaTracking(
            omnitureParams.mediatitle,
            omnitureParams.mediaduration,
            omnitureParams.mediaplayer
          );
        }
      });

      kalturaPlayer.addEventListener(kalturaPlayer.Event.PLAY, (e) => {
        window.omniMediaTrackingResume(
          omnitureParams.mediatitle,
          e.target.currentTime
        );
      });

      kalturaPlayer.addEventListener(kalturaPlayer.Event.FIRST_PLAYING, (e) => {
        analytics.callOmniload(kalturaPlayer);
      });

      [
        kalturaPlayer.Event.SEEKED,
        kalturaPlayer.Event.PAUSE,
        kalturaPlayer.Event.ABORT,
        kalturaPlayer.Event.ENDED,
      ].forEach((event) =>
        kalturaPlayer.addEventListener(event, (e) => {
          window.omniMediaTrackingStop(
            omnitureParams.mediatitle,
            e.target.currentTime
          );
        })
      );
    } catch (e) {
      console.error(e.message);
    }
  };

  render() {
    return <div id="meWATCHPlayer"></div>;
  }
}

export default Player;
